import React from "react";
import moment from "moment";

const handleValidDate = (date:any) => {
  // Handle different input types to avoid moment.js deprecation warnings
  if (date instanceof Date) {
    // Convert Date to timestamp to avoid deprecation warning
    return moment(date.getTime()).format("DD MMM Y");
  } else if (typeof date === 'number') {
    // Already a timestamp
    return moment(date).format("DD MMM Y");
  } else if (typeof date === 'string') {
    // Try parsing with specific formats to avoid deprecation warnings
    const formats = ['DD MMM Y', 'DD MMM, YYYY', 'YYYY-MM-DD', moment.ISO_8601];
    const parsed = moment(date, formats, true);
    if (parsed.isValid()) {
      return parsed.format("DD MMM Y");
    }
    // If format parsing fails, try ISO format
    const isoParsed = moment(date, moment.ISO_8601, true);
    if (isoParsed.isValid()) {
      return isoParsed.format("DD MMM Y");
    }
    // Last resort: try with new Date
    try {
      return moment(new Date(date).getTime()).format("DD MMM Y");
    } catch {
      return date;
    }
  }
  // Fallback
  try {
    return moment(new Date(date).getTime()).format("DD MMM Y");
  } catch {
    return date;
  }
};

const handleValidTime = (time:any) => {
  const time1 = new Date(time);
  const getHour = time1.getUTCHours();
  const getMin = time1.getUTCMinutes();
  const getTime = `${getHour}:${getMin}`;
  var meridiem = "";
  if (getHour >= 12) {
    meridiem = "PM";
  } else {
    meridiem = "AM";
  }
  const updateTime = moment(getTime, 'hh:mm').format('hh:mm') + " " + meridiem;
  return updateTime;
};

const Rating = (cell:any) => {
  return (
    <React.Fragment>
      <span>
        <span className="badge bg-light text-body fs-12 fw-medium">
          <i className="mdi mdi-star text-warning me-1"></i>{cell.getValue()}
        </span>
      </span>
    </React.Fragment>
  );
};

const Published = (cell:any) => {
  return (
    <React.Fragment>
      <span>
        {handleValidDate(cell.getValue())}
        <small className="text-muted ms-1">{handleValidTime(cell.getValue())}</small>
      </span>
    </React.Fragment>
  );
};

const Price = (cell:any) => {
  return (
    <React.Fragment>
      {"$ " + cell.getValue() + ".00"}
    </React.Fragment>
  );
};

export { Rating, Published, Price };
